
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#e7eced","d":"M11.238 25.088l-4.774 2.604a4.33 4.33 0 00-.766.545A15.924 15.924 0 0016 32c3.897 0 7.467-1.395 10.242-3.71a4.227 4.227 0 00-.842-.564l-5.112-2.556a1.948 1.948 0 01-1.078-1.744V21.42c.144-.164.308-.374.484-.622a11.753 11.753 0 001.589-3.202 1.606 1.606 0 001.139-1.528v-2.141c0-.471-.209-.892-.535-1.186V9.646S22.523 4.83 16 4.83s-5.887 4.816-5.887 4.816v3.095a1.596 1.596 0 00-.535 1.186v2.141c0 .564.296 1.06.74 1.347.535 2.329 1.936 4.005 1.936 4.005v1.956a1.952 1.952 0 01-1.017 1.71z"}}),_c('path',{attrs:{"fill":"#d3d3d3","d":"M16.273.002C7.438-.149.153 6.891.002 15.726c-.086 5.01 2.147 9.512 5.702 12.506.232-.203.482-.389.759-.54l4.774-2.604a1.95 1.95 0 001.016-1.712V21.42s-1.401-1.676-1.936-4.005a1.606 1.606 0 01-.74-1.347v-2.141c0-.471.21-.892.535-1.186V9.646S9.476 4.83 15.999 4.83s5.887 4.816 5.887 4.816v3.095c.326.295.535.715.535 1.186v2.141c0 .72-.483 1.325-1.139 1.528a11.739 11.739 0 01-1.589 3.202c-.176.248-.34.458-.484.622v2.006a1.95 1.95 0 001.078 1.744l5.112 2.556c.307.153.584.347.839.563a15.958 15.958 0 005.758-12.015C32.148 7.439 25.109.154 16.273.003z"}})])
          )
        }
      }
    